import Base from './base'

export interface IInterestRateTier {
  id: string
  clientName: string
  balanceThreshold: number
  interestRateBase: number
  interestRateAbovePrime: number
  effectiveRate?: number
  createdAt: string
  updatedAt: string
}

export default class InterestRateTier extends Base {
  list(clientName: string) {
    return this.apiClient.get('interest-rate-tiers', { clientName })
  }
}
